import { Box } from '@mui/material';
import ActivityListTableView from './ActivityListTableView';
import TitleText from '../../components/formlib/TitleText';
import MediumTypography from '../../components/formlib/MediumTypography';
import { useState, useEffect, useContext } from 'react';
import {
  STORAGE_USER_ID_KEY,
  SELECTED_PROGRAM_KEY,
} from '../../services/Constant';
import {
  Activity,
  ActivitySheet,
  Appointment,
  getWeeklyActivitySheet,
} from '../../services/configApi/activitySheet/weeklyActivitySheetProvider';
import { formatDate, getFiscalYearInfo } from '../../utils/dateUtil';
import { useIntl } from 'react-intl';
import FilterSelection from '../../components/formlib/FilterSelection';
import {
  ApiError,
  ApiMessage,
  isCustomError,
} from '../../services/ApiResponseHandler';
import { FilterStatuses } from './activityUtils';
import { LoaderContext, LoaderContextType } from '../../layouts/AppSidebar';
import SnackBarComponent from '../../components/formlib/SnackBarComponent';
import { OptionType, ResponseType } from '../../utils/type';
import WeekDatePicker from '../../components/formlib/modal/WeekDatePicker';
import dayjs, { Dayjs } from 'dayjs';
import ProductivityChart from './ProductivityChart';
import { Context } from '../../LanguageWrapper';
import {
  Holiday,
  getHolidayList,
} from '../../services/configApi/employees/holidayServices';
import HolidayListDialog from '../holidays/HolidayListDialog';
import { useLocation } from 'react-router';
import ActivitySheetWeekPeekNew from './ActivitySheetWeekPeekNew';
import { ActivitySheetContextProvider } from '../../context/ActivitySheetContext';
import { getEmployeeTimeOffBalances } from '../../services/myTimeoff/MyTimeoffApi';
import TimeOffBalanceDialogue from './TimeOffBalanceDialogue';
import { TimeOutLogCardData } from '../profile/TimeOffBalancesCard';
const EmployeeActivityDashboard = () => {
  const rctl = useIntl();
  const location = useLocation();
  const navParams = location.state;
  const [selectedDate, setSelectedDate] = useState<Date>(
    navParams?.date ? (navParams.date as Date) : new Date(),
  );
  const [selectedStatus, setSelectedStatus] = useState<string | null>(null);
  const [originalActivities, setOriginalActivities] = useState<ActivitySheet>();
  const [activityDetails, setActivityDetails] = useState<ActivitySheet>();
  const [reload, setReload] = useState<boolean>(true);
  const [toastrId, setToastrId] = useState<string>();
  const [successOrError, setSuccessOrError] = useState<ResponseType>('success');
  const [defaultlabel, setDefaultlabel] = useState<string>();
  const { toggleLoader } = useContext(LoaderContext) as LoaderContextType;
  const [showHolidays, setShowHolidays] = useState<boolean>(false);
  const [holidays, setHolidays] = useState<Holiday[]>([]);
  const context = useContext(Context);
  const [needProductivity, setNeedProductivity] = useState<boolean>(false);
  const [tbbTimeOffBalances, setTbbTimeOffBalances] = useState<
    TimeOutLogCardData[]
  >([]);
  const [showTimeOffBalances, setShowTimeOffBalances] =
    useState<boolean>(false);
  useEffect(() => {
    if (reload) {
      getActvitySheet(selectedDate);
    }
  }, [reload, selectedDate]);

  const viewProductivity = () => {
    setNeedProductivity(true);
    setReload(true);
  };

  const getActvitySheet = (newDate: Date) => {
    const userId = localStorage.getItem(STORAGE_USER_ID_KEY);
    if (userId === null) {
      return;
    }
    toggleLoader(true);
    getWeeklyActivitySheet(
      formatDate(newDate, 'MM/DD/YYYY'),
      userId,
      needProductivity,
    )
      .then((response0: ActivitySheet) => {
        response0.activities?.forEach((activity) => {
          activity.appointments?.forEach((appt) => {
            appt.attendeeId = userId;
          });
        });
        response0.activities?.forEach((activity) => {
          if (activity.appointments && activity.appointments.length > 0) {
            const dayAppointments: Map<string, Appointment[]> = new Map();
            activity.appointments?.forEach((appt) => {
              if (dayAppointments.has(appt.appointmentId)) {
                const appts = dayAppointments.get(appt.appointmentId);
                if (appts) {
                  appts.push(appt);
                  dayAppointments.set(appt.appointmentId, appts);
                }
              } else {
                dayAppointments.set(appt.appointmentId, [appt]);
              }
            });

            activity.appointments = [];
            activity.groupBilling = [];

            dayAppointments.forEach((appts) => {
              if (appts.length === 1) {
                activity.groupBilling.push({
                  isGroupBilling: false,
                  apptTime: appts[0].startTime ?? '',
                  hasInterpreter: false,
                  appointmentId: appts[0].appointmentId,
                  attendeeId: appts[0].attendeeId ?? '',
                  appointmentType: appts[0].appointmentType,
                  groupBillingStartTime: null,
                  groupBillingDurationDec: null,
                  appointments: appts,
                });
              } else {
                const clientIds = new Set<string>();

                appts.forEach((appointment) =>
                  clientIds.add(appointment.clientId),
                );
                if (clientIds.size === 1) {
                  activity.groupBilling.push({
                    isGroupBilling: false,
                    apptTime: appts[0].startTime ?? '',
                    hasInterpreter: false,
                    appointmentId: appts[0].appointmentId,
                    attendeeId: appts[0].attendeeId ?? '',
                    appointmentType: appts[0].appointmentType,
                    groupBillingStartTime: null,
                    groupBillingDurationDec: null,
                    appointments: appts,
                  });
                } else {
                  const hasInterpreter = appts.some(
                    (appt) => appt.attendeeRole !== 'CLINICIAN',
                  );
                  const attendeeId = localStorage.getItem('userId');
                  activity.groupBilling.push({
                    isGroupBilling: !hasInterpreter,
                    apptTime: appts[0].startTime ?? '',
                    hasInterpreter: hasInterpreter,
                    appointmentId: appts[0].appointmentId,
                    attendeeId: attendeeId ?? '',
                    appointmentType: appts[0].appointmentType,
                    groupBillingStartTime: appts[0].groupBillingStartTime,
                    groupBillingDurationDec:
                      appts[0].groupBillingDurationDec !== null
                        ? appts[0].groupBillingDurationDec
                        : null,
                    appointments: appts,
                  });
                }
              }
            });
          } else {
            activity.groupBilling = [];
          }
        });
        setOriginalActivities(response0);
        return response0;
      })
      .then((response) => {
        return JSON.parse(JSON.stringify(formatAndReadResponse(response)));
      })
      .then((response1) => {
        setActivityDetails(response1);
        setSelectedStatus(null);
        toggleLoader(false);
        setReload(false);
      })
      .catch((error) => {
        setSuccessOrError('error');
        toggleLoader(false);
        if (isCustomError(error)) {
          setReload(false);
          const apiError = error as ApiError;
          setToastrId(apiError.id);
          setDefaultlabel(apiError.message);
        } else {
          const response = error as ApiMessage;
          if (response.code === 400) {
            setReload(false);
            setToastrId('contactAdminErrorMessage');
            setDefaultlabel('Please contact administrator');
          } else if (response.code === 1146) {
            setToastrId('employeeInactiveErrorMessage');
            setDefaultlabel('Employee is In-active for the selected week.');
          }
        }
      });
  };

  const readHolidayList = () => {
    const program = context.selectedProgram;
    if (!program || !selectedDate) {
      return;
    }
    toggleLoader(true);
    const { startYear, endYear } = getFiscalYearInfo(selectedDate);
    getHolidayList(startYear, endYear, program.id)
      .then((response) => {
        toggleLoader(false);
        setShowHolidays(true);
        setHolidays(response.holidayList);
      })
      .catch(() => {
        toggleLoader(false);
      });
  };

  const formatAndReadResponse = (response: ActivitySheet) => {
    let rowId = 0;
    const newResponse: ActivitySheet = {
      ...response,
      activities:
        response.activities?.map((activity, index, arrayActivities) => {
          if (index === 0) {
            activity.rowId = rowId;
          } else {
            const previousActivity = arrayActivities[index - 1];
            if (previousActivity.day !== activity.day) {
              rowId = rowId === 0 ? 1 : 0;
            }
            activity.rowId = rowId;
          }
          return activity;
        }) ?? [],
    };
    newResponse.activities?.forEach((activity) => {
      if (activity.groupBilling.length > 0) {
        activity.groupBilling.forEach((gb) => {
          // Sort appointments based on clientLastName
          gb.appointments.sort((a, b) => {
            if (a.clientLastName < b.clientLastName) return -1;
            if (a.clientLastName > b.clientLastName) return 1;
            return 0;
          });
        });
        const gbLastIndex = activity.groupBilling.length - 1;
        const apptLastIndex =
          activity.groupBilling[gbLastIndex].appointments.length - 1;
        activity.groupBilling.forEach((gb, index) => {
          if (index === gbLastIndex) {
            gb.appointments.forEach((appt, i) => {
              appt.isLastIndex = i === apptLastIndex;
              return appt;
            });
          }
        });
      }
      return activity;
    });
    return newResponse;
  };

  const filterActivities = (filter: string | null) => {
    if (originalActivities && activityDetails) {
      if (filter === null) {
        const activitiesCopy = JSON.parse(
          JSON.stringify(originalActivities.activities),
        ) as Activity[];
        setActivityDetails({
          ...activityDetails,
          activities: activitiesCopy,
        });
        return;
      }
      const activities = originalActivities.activities;
      const filteredActivities =
        activities?.filter((activity) => {
          return activity.status === rctl.formatMessage({ id: filter });
        }) ?? [];

      const filteredActivitiesCopy = JSON.parse(
        JSON.stringify(filteredActivities),
      ) as Activity[];
      let day =
        filteredActivitiesCopy.length > 0 ? filteredActivitiesCopy[0].day : '';
      let rowId = 0;
      const finalActivities = filteredActivitiesCopy.filter(
        (activity, index, arrayActivities) => {
          if (index === 0) {
            activity.rowId = rowId;
          }
          if (index !== 0) {
            const item = arrayActivities[index].day;
            if (day === item) {
              activity.day = '';
              activity.rowId = rowId;
            } else {
              rowId = rowId === 0 ? 1 : 0;
              activity.rowId = rowId;
              day = activity.day;
            }
          }
          return activity;
        },
      );

      setActivityDetails({
        ...activityDetails,
        activities: finalActivities,
      });
    }
  };

  const getEmployeeType = () => {
    return activityDetails?.employeeType ?? '';
  };

  const updateNoteErrorMessage = (
    errorType: ResponseType,
    id: string,
    message: string,
  ) => {
    setSuccessOrError(errorType);
    setToastrId(id);
    setDefaultlabel(message);
  };

  const updateVisitLevelNote = (
    progressNotesId: string,
    visitId: string,
    description: string,
  ) => {
    if (activityDetails?.activities && activityDetails.activities.length > 0) {
      const activities = activityDetails.activities.map((activity) => {
        for (const appt of activity.appointments ?? []) {
          if (
            appt.progressNotesId === progressNotesId &&
            appt.visitId === visitId
          ) {
            appt.description = description;
            break;
          }
        }
        for (const appt of activity.groupBilling) {
          for (const a of appt.appointments) {
            if (
              a.progressNotesId === progressNotesId &&
              a.visitId === visitId
            ) {
              a.description = description;
              break;
            }
          }
        }
        return activity;
      });
      setActivityDetails({ ...activityDetails, activities: activities });
    }
  };
  const fetchTbbTimeOffBalances = () => {
    const { startYear, endYear } = getFiscalYearInfo(selectedDate);
    const employeeId = localStorage.getItem(STORAGE_USER_ID_KEY);
    const selectedProgramStr = localStorage.getItem(SELECTED_PROGRAM_KEY);
    if (
      employeeId &&
      selectedProgramStr &&
      `07/01/${startYear}` &&
      `06/30/${endYear}`
    ) {
      const programId = (JSON.parse(selectedProgramStr) as OptionType).id;
      toggleLoader(true);
      getEmployeeTimeOffBalances(
        programId,
        employeeId,
        `07/01/${startYear}`,
        `06/30/${endYear}`,
      )
        .then((res) => {
          setTbbTimeOffBalances(res);
          setShowTimeOffBalances(true);
          toggleLoader(false);
        })
        .catch((error) => {
          console.error('Failed to load TBB time off balances', error);
          toggleLoader(false);
          setSuccessOrError('error');
          if (isCustomError(error)) {
            const apiError = error as ApiError;
            setToastrId(apiError.id);
            setDefaultlabel(apiError.message);
          } else {
            setToastrId('failedProfileTimeoffMessage');
            setDefaultlabel('Failed to fetch Employee Time off Summary cards');
            setSuccessOrError('error');
          }
        });
    }
  };
  return (
    <Box component="main">
      {toastrId && (
        <SnackBarComponent
          open={toastrId !== undefined}
          handleClose={() => {
            setToastrId(undefined);
          }}
          labelId={toastrId}
          defaultMessageId={defaultlabel}
          successOrError={successOrError}
        />
      )}
      {showHolidays && (
        <HolidayListDialog
          open={showHolidays}
          date={selectedDate ?? new Date()}
          holidays={holidays}
          onClose={() => setShowHolidays(false)}
        />
      )}
      {showTimeOffBalances && (
        <TimeOffBalanceDialogue
          open={showTimeOffBalances}
          tbbTimeOffBalances={tbbTimeOffBalances}
          onClose={() => setShowTimeOffBalances(false)}
        />
      )}
      {activityDetails && (
        <Box>
          <Box
            component={'section'}
            sx={{
              padding: '12px 0px',
              display: 'flex',
              flexDirection: 'row',
            }}
            justifyContent={'space-between'}
            alignItems={'center'}
          >
            <TitleText
              labelid="myActivitySheetText"
              defaultlabel="My Weekly Activity Sheet"
            />
            <Box
              sx={{
                marginRight: '8px',
                alignSelf: 'center',
                marginLeft: 'auto',
              }}
              onClick={() => {
                fetchTbbTimeOffBalances();
              }}
            >
              <MediumTypography
                sxProps={{ color: '#008C82', cursor: 'pointer' }}
                labelid={`${rctl.formatMessage({
                  id: 'timeOutLogsText',
                  defaultMessage: 'Time Out Logs',
                })} ${dayjs().format('YYYY')}`}
                defaultlabel="Time Out Logs"
              />
            </Box>
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
            }}
            justifyContent={'space-between'}
            alignItems={'center'}
          >
            <Box sx={{ display: 'flex' }} alignItems={'center'}>
              <WeekDatePicker
                date={dayjs(selectedDate)}
                maxDate={
                  activityDetails.employeeEndDate
                    ? dayjs(activityDetails.employeeEndDate)
                    : dayjs().add(4, 'week').endOf('week')
                }
                onDateSelect={(newDate: Dayjs) => {
                  setReload(true);
                  setSelectedDate(newDate.toDate());
                  setOriginalActivities(undefined);
                  setActivityDetails(undefined);
                  setSelectedStatus(null);
                }}
              />
              <MediumTypography
                label={`${rctl.formatMessage({
                  id: 'employeeTypeText',
                  defaultMessage: 'Employee Type:',
                })} : `}
                sxProps={{ marginLeft: '16px', color: '#97A6A5' }}
              />
              <MediumTypography
                label={getEmployeeType()}
                defaultlabel="-"
                sxProps={{ color: '#008C82', marginLeft: '8px' }}
              />

              {getEmployeeType() !== 'Salaried Exempt' && (
                <Box className="flex__ ml-lg alignItemCenter">
                  <MediumTypography
                    labelid={'lunchWaiverText'}
                    defaultlabel="Lunch Waiver"
                    sxProps={{ color: '#97A6A5' }}
                  />
                  <MediumTypography
                    label={':'}
                    className="mr-sm"
                    sxProps={{ color: '#97A6A5' }}
                  />
                  <MediumTypography
                    label={activityDetails.lunchWaiverRequired ? 'Yes' : 'No'}
                    sxProps={{ color: '#008C82' }}
                  />
                </Box>
              )}
            </Box>

            <Box
              sx={{ display: 'flex', cursor: 'pointer' }}
              onClick={() => {
                readHolidayList();
              }}
            >
              <MediumTypography
                sxProps={{ color: '#008C82', cursor: 'pointer' }}
                labelid={`${rctl.formatMessage({
                  id: 'holiday(s)Text',
                  defaultMessage: 'Holiday(s)',
                })} ${dayjs().format('YYYY')}`}
                defaultlabel="Holiday(s)"
              />
            </Box>
          </Box>

          <Box
            component={'section'}
            sx={{
              display: 'flex',
              marginTop: '12px',
              flexDirection: 'row',
              width: '100%',
            }}
          >
            <ActivitySheetWeekPeekNew
              employeeType={activityDetails.employeeType}
              activity={activityDetails}
              cardStyle={{
                width:
                  activityDetails.employeeType !== 'Hourly Non-Exempt'
                    ? '60%'
                    : '100%',
                marginRight:
                  activityDetails.employeeType === 'Hourly Non-Exempt'
                    ? '0px'
                    : '8px',
              }}
            />

            {activityDetails.employeeType !== 'Hourly Non-Exempt' && (
              <ProductivityChart
                barHeight="150px"
                cardStyle={{ width: '40%' }}
                productivity={activityDetails.productivity}
                horizontalValue={activityDetails.productivityThreshold}
                viewProductivity={viewProductivity}
              />
            )}
          </Box>

          <Box
            component={'section'}
            display={'flex'}
            marginTop={'12px'}
            alignItems={'center'}
            justifyContent={'space-between'}
          >
            <MediumTypography
              sxProps={{
                fontWeight: 600,
              }}
              labelid="activitySheetRememberNoteText"
              defaultlabel="Remember to complete and submit your activity sheets & notes on Friday"
            />
            <Box sx={{ display: 'flex' }}>
              <FilterSelection
                hintTextId="FiterText"
                value={selectedStatus}
                items={FilterStatuses}
                onSelect={(value) => {
                  if (value === null) {
                    if (originalActivities) {
                      const newResponse =
                        formatAndReadResponse(originalActivities);
                      setActivityDetails(newResponse);
                    }
                  } else {
                    setActivityDetails(undefined);
                    filterActivities(value);
                  }
                  setSelectedStatus(value);
                }}
              />
            </Box>
          </Box>

          <ActivitySheetContextProvider
            updateVisitLevelNote={updateVisitLevelNote}
            updateNoteErrorMessage={updateNoteErrorMessage}
            activityStatus={activityDetails.status}
          >
            <ActivityListTableView
              filterStatus={selectedStatus}
              selectedDate={selectedDate}
              employeeType={activityDetails.employeeType}
              activities={activityDetails.activities ?? []}
              setReload={setReload}
              status={activityDetails.status}
              reload={reload}
              isEmployee={true}
              screenName="EmployeeActivity"
              handleNoteUpdate={(activitySheetId, note) => {
                if (activityDetails) {
                  const activities =
                    activityDetails.activities?.map((activity) => {
                      if (activity.activitySheetId === activitySheetId) {
                        activity.description = note;
                      }
                      return activity;
                    }) ?? [];
                  setActivityDetails({
                    ...activityDetails,
                    activities: activities,
                  });
                }
              }}
            />
          </ActivitySheetContextProvider>
        </Box>
      )}
    </Box>
  );
};

export default EmployeeActivityDashboard;
